var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',[_c('v-col',{staticClass:"mx-auto",attrs:{"md":"9","sm":"12","cols":"12"}},[_c('TwoAuthenticator'),_c('AtividadesRecentes'),_c('AlterarSenhaPIN'),_c('Dispositivos')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }